/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetEnrichedPlaidDataRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetEnrichedPlaidData.pb'
import {GetEnrichedPlaidDataResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetEnrichedPlaidData.pb'


export const getEnrichedPlaidData = (request:GetEnrichedPlaidDataRequest, options?: CashRequestOptions) => post<GetEnrichedPlaidDataRequest, GetEnrichedPlaidDataResponse>("/2.0/cash/get-enriched-plaid-data", request, {...options, rejectOnError: true })